/**
 * Created by Karol Kluska on 19.12.17.
 */

angular
  .module('app')
  .filter('datepickerTranslateDay', translateDay);

function translateDay($interpolate) {
  return function (input) {
    return input.toUpperCase()
      .replace(/MON/g, $interpolate('{{ \'weekdays_short.MON\' | translate}}'))
      .replace(/TUE/g, $interpolate('{{ \'weekdays_short.TUE\' | translate}}'))
      .replace(/WED/g, $interpolate('{{ \'weekdays_short.WED\' | translate}}'))
      .replace(/THU/g, $interpolate('{{ \'weekdays_short.THU\' | translate}}'))
      .replace(/FRI/g, $interpolate('{{ \'weekdays_short.FRI\' | translate}}'))
      .replace(/SAT/g, $interpolate('{{ \'weekdays_short.SAT\' | translate}}'))
      .replace(/SUN/g, $interpolate('{{ \'weekdays_short.SUN\' | translate}}'))
      ;
  };
}
